"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlDefinition = void 0;
const helpers_1 = require("@wix/services-manager/helpers");
exports.UrlDefinition = (0, helpers_1.defineService)('viewer-core/viewer-service-url');
//# sourceMappingURL=index.js.map